export default __webpack_public_path__ + "static/og-f5249a861b77822d7fb3db9b5fc1bde6.png";